// Uploads a survey-export template workbook and stores its URL on the project
// or property row (excel_template_url), which switches the step-4 export to
// server-side generation. Storage mechanics mirror robotic-imaging-web's
// project-file upload: bytes to Firebase Storage at project_files/{uuid}.{ext}
// with the original filename in metadata, then getDownloadURL — those URLs are
// plain-GET fetchable, which is the column's contract.

import { getDownloadURL, ref, uploadBytes } from "@firebase/storage";
import { firebaseStorage } from "@/shared/integrations/firebase/client";
import { supabase } from "@/shared/integrations/supabase/client";

export async function uploadExcelTemplate(
  file: File,
  target: { kind: "project" | "property"; id: string }
): Promise<string> {
  const ext = file.name.match(/\.([^.]+)$/)?.[1] ?? "xlsx";
  const filepath = `project_files/${crypto.randomUUID()}.${ext}`;
  const storageRef = ref(firebaseStorage, filepath);

  await uploadBytes(storageRef, file, {
    contentDisposition: `inline; filename="${file.name}"`,
    customMetadata: {
      originalFilename: file.name,
      purpose: "survey-export-template",
      targetKind: target.kind,
      targetId: target.id,
    },
  });
  const url = await getDownloadURL(storageRef);

  const { error } = await supabase
    .from(target.kind === "project" ? "projects" : "properties")
    .update({ excel_template_url: url })
    .eq("id", target.id);
  if (error) throw error;

  return url;
}
